import { FunctionComponent, PropsWithChildren } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

interface InlineTooltipProps {
  title: string;
  aschild?: boolean;
}

const InlineTooltip: FunctionComponent<
  PropsWithChildren<InlineTooltipProps>
> = ({ children, title, aschild }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild={aschild}>{children}</TooltipTrigger>
        <TooltipContent>{<p>{title}</p>}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InlineTooltip;
